<template>
  <div class="container">
    <ul class="breadcrumbs">
      <li>
        <a href="https://www.brighton.com">Home</a>
      </li>
      <li>
        <a href="https://app.brighton.com/design-a-tote/submit">Design A Tote</a>
      </li>
    </ul>
    <div v-if="!submitted">
      <!-- <logo /> -->
      <div class="banner">
        <div class="staticPopTextWrapper">
            <div class="img-button-container">
                
                <img
                src="https://app.brighton.com/design-a-tote/img/final-banner-1.jpg?1"
                alt
                class="bannerImg"
                />
                <!-- <a href="https://app.brighton.com/brighton-your-day"><button class="img-btn">View Activities </button></a> -->
                <!-- <router-link to="/"><button class="img-btn">View Activities</button></router-link> -->
            </div>
          <!-- <span class="popButterflyTopLargeText">STAYING SAFE?</span> -->
          <!--	<span class="popButterflyTopSmallText">of</span>-->
          	<!-- <span class="popButterflyTopLargeText"> PINK</span><br> -->
          <!-- <span class="popButterflyTopYears">&nbsp;</span> -->
          <!-- <br /> -->
          <span class="popButterflyTopRecognition">
           Have you ever dreamed of having your own unique design showcased on a beautiful accessory? Now's your chance. At Brighton, we love artists, and we have created a contest where one lucky designer will have their artwork chosen to be showcased on a handbag that will become part of a new Brighton collection.  The winner will also receive a $1,000 prize and a trip to our Los Angeles Design Studio.  Please upload your artwork along with your contact information and a brief description of your creation. The contest runs through August 1st, 2022.  Not all submissions will be posted online.</span>
        </div>
      </div>

      <div class="error" v-if="error != ''">{{error}}</div>
      <div class="links">
        <div class="row">
          <!-- <label for="">First Name</label> -->
          <input
            :class="{invalid: !firstName.valid}"
            type="text"
            maxlength="18"
            v-model="firstName.value"
            placeholder="First Name"
          />
          <input
            :class="{invalid: !lastName.valid}"
            type="text"
            maxlength="18"
            v-model="lastName.value"
            placeholder="Last Name"
          />
        </div>
        <div class="row">
          <input
            :class="{invalid: !emailAdd.valid}"
            v-model="emailAdd.value"
            type="email"
            placeholder="Email Address"
          />
          <VuePhoneNumberInput
            @input="updatePhone"
            :class="{invalid: !phone.valid}"
            v-model="phone.value"
            type="text"
            :label="'Phone Nmber'"
          />
          <!-- <label for="">Last Name</label> -->
        </div>
        <div class="row">
          <input
            :class="{invalid: !city.valid}"
            v-model="city.value"
            type="text"
            placeholder="Instagram Username (Optional)"
          />
          <select v-model="country" style="opacity:0" disabled>
            <option v-for="country in countries" v-bind:value="country.code">{{country.name}}</option>
          </select>
        </div>
        <div class="row">
          <label for>Brief description of design</label>
          <textarea
            :class="{invalid: !pictureLocation.valid}"
            v-model="pictureLocation.value"
            name
            id
            cols="30"
            rows="20"
          ></textarea>
        </div>
        <div class="row">
          <div class="wrapper" :class="{invalid: !uploadFile.valid}">
            <span class="label" v-html="uploadStatus"></span>
            <input type="file" @change="prepareFile($event.target.files)" />
          </div>
        </div>
        <div class="row"></div>
        <div class="row">
          <a @click="submit" href="#" target="_blank" class="button button--submit">
            <span v-if="processing">Processing. Please wait</span>
            <span v-else>Submit</span>
          </a>
          <a @click="reset" href="#" target="_blank" class="button button--reset">Reset</a>
        </div>
        <div class="row emailSignUp">
          <input type="checkbox" v-model="signUpToEmail"><span>Get a first look at new arrivals, promotions, and in store events by signing up for emails.</span>
        </div>
        <div class="row">
          <router-link to="/"><button class="img-btn viewSubmission">View submissions</button></router-link>
        </div>
        
        <div class="disclaimer">
          <!-- *PRIZE DETAILS: Round trip airfare for two (2) and 3 days/2 nights stay at the Surf and Sand Resort in Laguna Beach, California. No purchase necessary to enter or win. Prize is non-transferable. No substitutions or cash redemptions. Winner must be 18 years old, or, if older, the age of majority in state of residence. Prize winner and travel companion must be on same itinerary and must sign releases prior to ticketing. Travel companion must be age of majority unless the prize winner is travel companion's parent or legal guardian. Winner is responsible for all applicable federal, state and local taxes. Travel and accommodations subject to availability; restrictions and blackout dates may apply. Sponsor is not liable for delays, cancellation or unforeseen events. Void where prohibited by law. Contest runs until July 31, 2019.
          <br /> -->
          <br />*PHOTO RELEASE: I consent to the unrestricted use by Brighton Collectibles Inc. and his/her/its successors, assigns, and designees, and those acting with his/her/its permission and authority of any and all photographic or other images (“Images”) of me that Brighton Collectibles Inc. creates/created or makes/made from the Artful at Heart Design a Brighton Tote campaign for all purposes, in any form, and in any and all media, including, without limitation, advertising, solicitation, stock photography, or trade, to copyright same in Brighton Collectibles Inc.’s own name or any other name that he/she/it may choose, and the right to use my name in connection therewith if Brighton Collectibles Inc. so chooses.
        </div>
      </div>
    </div>
    <div v-else class="submittedInfo">
      <img
        v-if="submittedData.data != ''"
        :src="'https://app.brighton.com/brighton-your-day/tmp/' + submittedData.data"
        class="submittedImg"
      />
      <div>
        <!-- {{submittedData.firstName}}<br/>
            {{submittedData.lastName}}<br/>
            {{submittedData.phone}}<br/>
            {{submittedData.firstName}}<br/>
        {{submittedData.pictureLocation}}<br/>-->
      </div>
      <h2>Your submission has been received</h2>
      <!-- <router-link to="/" class="button">See Submissions</router-link> -->
      <a
        style="width:auto; padding: 0 20px; margin-top:30px;"
        href="https://www.brighton.com"
        class="button"
      >Back to Brighton.com</a>
    </div>
  </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
// import 'vue-phone-number-input/dist/vue-phone-number-input.css';

// import Logo from '~/components/Logo.vue'
import countries from "../../countries.json";
const axios = require("axios");
export default {
  data() {
    return {
      firstName: { value: "", valid: true },
      lastName: { value: "", valid: true },
      emailAdd: { value: "", valid: true },
      phone: { value: "", valid: true },
      uploadFile: { value: "", valid: true },
      uploadStatus: "Click to upload your file <ul><li>File must have a MAXIMUM of 8 colors.</li><li>Accepted file types include JPEG / PNG.</li><li>Resolution must be AT LEAST 200 DPI</li></ul>",
      pictureLocation: { value: "", valid: true },
      city: { value: "", valid: true },
      country: "US",
      error: "",
      submitted: false,
      submittedData: null,
      countries: null,
      subscriberKey: "",
      processing: false,
      signUpToEmail: true
    };
  },
  components: {
    // Logo
    VuePhoneNumberInput
  },
  async mounted() {
    // let { success } = await this.$axios.$post(`http://localhost:3000/api`)
    // console.log("mounted");
    // console.log(location.hash)
    // console.log(location.hash.split('#')[1])
    this.countries = countries;
    if (location.hash != "") this.subscriberKey = location.hash.split("#")[1];

    document
      .getElementById("VuePhoneNumberInput_phone_number")
      .addEventListener("keydown", e => {
        // console.log(e.code);
        if (
          e.code == "Backspace" &&
          this.phone.value[this.phone.value.length - 1] == ")"
        ) {
          // console.log("backspace");
          this.phone.value = this.phone.value.substring(
            0,
            this.phone.value.length - 1
          );
        }
      });
  },
  created() {
    // console.log("created");
  },
  methods: {
    updatePhone1(e) {
      // console.log("delete");
    },
    updatePhone(e) {
      // console.log("update phone", this.phone.value, this.phone.value.length);
      // console.log(e);
    },
    reset(e) {
      if (e) e.preventDefault();
      // this.uploadFile = ''
      this.firstName.value = "";
      this.firstName.valid = true;

      this.lastName.value = "";
      this.lastName.valid = true;

      this.emailAdd.value = "";
      this.emailAdd.valid = true;

      this.phone.value = "";
      this.phone.valid = true;

      this.pictureLocation.value = "";
      this.pictureLocation.valid = true;

      this.city.value = "";
      this.city.valid = true;

      this.uploadFile.valid = true;

      this.error = "";
      this.country = "US";

      this.uploadStatus = "Click to upload your file <ul><li>File must have a MAXIMUM of 8 colors.</li><li>Accepted file types include JPEG / PNG .</li><li>Resolution must be AT LEAST 200 DPI</li></ul>";
      this.$forceUpdate();
    },
    prepareFile(file) {
      this.uploadFile.value = file;
      this.uploadFile.valid = true;
      this.uploadStatus = this.uploadFile.value[0].name;
      // console.log(this.uploadFile.value[0]);
    },
    async submit(e) {
      if (e) e.preventDefault();

      if (this.processing) return false;
      else this.processing = true;

      this.error = "";

      this.firstName.valid = true;
      if (this.firstName.value.trim() == "") {
        this.firstName.valid = false;
        this.error = "Correct the following error";
      }
      this.lastName.valid = true;
      if (this.lastName.value.trim() == "") {
        this.lastName.valid = false;
        this.error = "Correct the following error";
      }

      this.emailAdd.valid = true;
      // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(myForm.emailAddr.value))
      if (
        this.emailAdd.value.trim() == "" ||
        !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
          this.emailAdd.value.trim()
        )
      ) {
        this.emailAdd.valid = false;
        this.error = "Correct the following error";
      }

      this.phone.valid = true;
      // if(this.phone.value.trim() == '') {
      //     this.phone.valid = false
      //     this.error = "Correct the following error"
      // }

      // this.city.valid = true;
      // if (this.city.value.trim() == "") {
      //   this.city.valid = false;
      //   this.error = "Correct the following error";
      // }

      this.pictureLocation.valid = true;
    //   this.uploadFile.valid = true;
    //   if (this.uploadFile.value == "") {
    //     this.uploadFile.valid = false;
    //     this.error = "Correct the following error";
    //   }

      if (this.error != "") {
        document.body.scrollTop = 100; // For Safari
        document.documentElement.scrollTop = 200; // For Chrome, Firefox, IE and Opera
        this.processing = false;
        return false;
      }

    //   console.log(this.uploadFile.value[0]);
      var formData = new FormData();
      if (this.uploadFile.value != "") {
        formData.append("userImage", this.uploadFile.value[0], "searchImage");
        if (this.uploadFile.value[0].size / 1000000 > 20) {
            this.error = "Please limit the file size to under 20MB";
            this.processing = false;
            return false;
        }
        if (
            this.uploadFile.value[0].type !== "image/jpeg" &&
            this.uploadFile.value[0].type !== "image/png" &&
            this.uploadFile.value[0].type !== "image/gif" &&
            this.uploadFile.value[0].type !== "image/bmp"
        ) {
            this.error = "Please use image in JPEG/PNG/GIF/BMP format";
            this.processing = false;
            return false;
        }
      }
      formData.append("firstName", this.firstName.value);
      formData.append("lastName", this.lastName.value);
      formData.append("emailAdd", this.emailAdd.value);
      formData.append("phone", this.phone.value);
      formData.append("pictureLocation", this.pictureLocation.value);
      formData.append("subscriberKey", this.subscriberKey);
      formData.append("city", this.city.value);
      formData.append("country", this.country);
      formData.append("signUpToEmail", this.signUpToEmail);

      let returnedData = await axios({
        method: "POST",
        url: `https://app.brighton.com/brighton-your-day/api/submit`,
        responseType: "json",
        data: formData,
        config: { headers: { "Content-Type": "multipart/form-data" } },
        onUploadProgress: e => {
          if (e.lengthComputable) {
            console.log(
              "e.loaded: %o, e.total: %o, percent: %o",
              e.loaded,
              e.total,
              (e.loaded / e.total) * 100
            );
            this.uploadStatus = ((e.loaded / e.total) * 100).toFixed(0) + "%";
          }
        }
      });
      if (returnedData.data.success) {
        this.submitted = true;
        this.submittedData = returnedData.data.data;
        document.body.scrollTop = 100; // For Safari
        document.documentElement.scrollTop = 100; // For Chrome, Firefox, IE and Opera
      } else {
        console.log(returnedData.data.data)
        this.error = returnedData.data.data.error;
        if(returnedData.data.data.type == 'email') {
          this.emailAdd.valid = false
          if(this.error.indexOf('Did you mean:') != -1) {
            this.emailAdd.value = this.error.substring(14);
            this.error +=  '?'
          }
        }
        //     this.phone.valid = false

        //     this.error = "Correct the following error"
      }
      this.processing = false;
    }
  }
};
</script>

<style lang="scss">
 #app .button {
    width: 50%;
    margin:0;
    box-sizing:border-box;
}
#app .button--reset{
  margin-left: 3px;
  width: calc(50% - 3px);
}
.container {
  max-width: 90%;
  margin: 0 auto;
  min-height: 54vh;
  display: block;
  justify-content: center;
  align-items: center;
  text-align: center;

  ul.breadcrumbs {
    display: block;
    list-style-type: none;
    margin-top: 10px;
    text-align: left;
    padding-left: 0;
  }
  ul.breadcrumbs li {
    display: inline-block;
    line-height: 1;
    background: url(https://www.brighton.com/store_image/site/arrow.gif) 0
      center no-repeat;
    /* background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zd…c4LDE5Ljc4LDAsMCwxLDM4LTcuNywxOS43OCwxOS43OCwwLDAsMSwzOCw3LjdaJy8+PC9zdmc+); */
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA3NiA2Ny40Jz48ZGVmcz48c3R5bGU+LmF7ZmlsbDojOTE5MTkxO308L3N0eWxlPjwvZGVmcz48dGl0bGU+aGVhcnQ8L3RpdGxlPjxwYXRoIGNsYXNzPSdhJyBkPSdNNzYsMTkuOGEyOC40NSwyOC40NSwwLDAsMS0yLDkuN0M2OC4zLDQzLjcsMzcuOCw2Ny40LDM3LjgsNjcuNFM4LDQ0LjUsMi4xLDI5LjRBMzAuNDksMzAuNDksMCwwLDEsMCwxOS44YTE5Ljc4LDE5Ljc4LDAsMCwxLDM4LTcuNywxOS43OCwxOS43OCwwLDAsMSwzOCw3LjdaJy8+PC9zdmc+);
  }
  ul.breadcrumbs li a {
    font-weight: normal;
    display: block;
    text-decoration: none;
    margin-left: 11px;
    margin-right: 10px;
    color: black;
    /* background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zd…c4LDE5Ljc4LDAsMCwxLDM4LTcuNywxOS43OCwxOS43OCwwLDAsMSwzOCw3LjdaJy8+PC9zdmc+); */
    /* background: url(https://www.brighton.com/store_image/site/arrow.gif) no-repeat; */
    /* background: url(https://www.brighton.com/store_image/site/arrow.gif) 0 center no-repeat; */
    padding-left: 9px;
    background-position: 0 50%;
  }
  ul.breadcrumbs li a:hover {
    text-decoration: underline;
  }

  .disclaimer {
    padding-top: 40px;
    display: block;
    text-align: center;
    font-size: 12px;
    margin: 0 5px;
    font-family: "Lato", Arial, Helvetica, sans-serif;
    color: #000000;
    line-height: 1.4 !important;
  }
  .error {
    color: #ee3f86;
    font-weight: bold;
    line-height: 3;
  }
  .banner {
    .staticPopTextWrapper{
        position:relative;
        width:100%;
        button{
            position: relative;
            // top: 90%;
            // left: 50%;
            // -webkit-transform: translate(-50%, 0%);
            // transform: translate(-50%, 0%);
            // -ms-transform: translate(-50%, 0%);
            display: inline-block;
            padding: 14px 54px;
            line-height: 1.2em;
            color: #fff;
            background: black;
            font-weight: 600;
            font-size: 16px;
            border:0;
            text-transform: uppercase;
            letter-spacing: 0.3em;
            min-width: 280px;
            margin: 10px auto 30px auto;
        }
    }
    .popButterflyTopLargeText {
      display: block;
      text-align: center;
      font-size: 5em;
      /*		line-height: 0em;*/
      /*		margin-top: 1em;*/
      /*		margin-bottom: .5em;*/
      font-family: "Lato";
      font-weight: 600;
      letter-spacing: 0.1em;
      color: #1d3a5c;
      line-height: 1.5em;
    }
    .popButterflyTopYears {
      display: block;
      text-align: center;
      font-size: 2.5em;
      text-transform: uppercase;
      /*		line-height: 0em;*/
      /*		margin-top: 1em;*/
      margin-bottom: 0.5em;
      font-family: "Lato";
      font-weight: 600;
      letter-spacing: 0.08em;
      color: #1d3a5c;
    }

    .popButterflyTopRecognition {
      display: block;
      text-align: center;
      font-size: 1.5em;
      line-height: 1.4em;
      /*		margin-top: 1em;*/
      margin-bottom: 0.5em;
      font-family: "Lato";
      font-weight: 400;
      letter-spacing: 0em;
      color: black;
      padding:0 30px;
    }

    .bannerImg {
      width: 100%;
      display: block;
    }
  }

  .row {
    text-align: center;
    display: inline-block;
    width: 100%;
    padding: 10px;
    vertical-align: middle;
    
    a {
      button.viewSubmission{
        position: relative;
        display: inline-block;
        padding: 14px 54px;
        line-height: 1.2em;
        color: #fff;
        background: black;
        font-weight: 600;
        font-size: 16px;
        border: 0;
        text-transform: uppercase;
        letter-spacing: 0.3em;
        min-width: 280px;
        margin: 10px auto 30px auto;
      }
    }
    label {
      display: block;
    }
    .country-selector,
    .field-label {
      display: none;
    }
    .wrapper {
      .label {
        position: absolute;
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 3;
        z-index: -1;
        ul{
          line-height:1;
          margin:0;
          text-align: left;
          margin-left:75px;
        }
      }

      position: relative;
      border: 3px dotted gray;
      width: 50%;
      height: 135px;
      margin: 0 auto;
      input[type="file"] {
        opacity: 0;
        width: 100%;
        cursor: pointer;
        height: 100%;
      }
    }
  }
  .row.emailSignUp{
      text-align:left;
  }

  #VuePhoneNumberInput_phone_number {
    height: 38px;
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding: 0px 3px;
    font-size: 18px;
    font: normal 18px/44px "Muli", Arial, Helvetica, sans-serif;
    border: none;
    background: none;
    color: #666;
    text-indent: 12px;
  }

  input[type=text],
    input[type=email],
    /* input[type=tel], */
    select,
    .vue-phone-number-input,
    textarea {
    text-indent: 12px;
    display: block;
    box-sizing: border-box;
    /* width:50%; */
    /* padding: 0 5px; */
    outline: 0;
    color: #666;
    width: 48%;
    margin: 0px 2px;
    vertical-align: middle;
    height: 44px;
    background-color: #fafafa;
    display: inline-block;
    border: 3px solid #c2c2c2;
    font: normal 18px/44px "Muli", Arial, Helvetica, sans-serif;
  }
  textarea {
    width: 100%;
    height: 100px;
  }
  .field input[type="text"] {
    width: 100%;
  }
  input.invalid,
  .invalid {
    border-color: #ee3f86 !important;
  }

  .submittedInfo {
    img.submittedImg {
      width: 100%;
      max-width: 400px;
      /* width: auto; */
      margin: 30px 0;
    }
  }
}

/*	media query*/
@media (max-width: 960px) {
  .container .row .wrapper .label ul{
    margin: 0;
    text-align:left;
  }
}
@media (max-width: 800px) {
  .popButterflyTopLargeText {
    font-size: 3em;
  }

  .popButterflyTopYears {
    font-size: 2em;
  }

  .popButterflyTopRecognition {
    font-size: 1.5em;
    padding: 0 20px;
  }
}
@media (max-width: 765px) {
  .container .row .wrapper {
    width: auto;
  }
  .container .banner .popButterflyTopLargeText {
    line-height: 1em;
  }
}

@media (max-width: 455px) {
  #app .button {
    width: 100%;
    margin:0;
    margin-bottom:3px;
  }
}
@media (max-width: 415px) {
  .container input[type="text"],
  .container input[type="email"],
  .container select,
  .container .vue-phone-number-input,
  .container textarea {
    width: 100%;
    margin: 5px 0;
  }
  .container .row {
    padding: 0;
  }
  .container .row.emailSignUp{
    padding:5px;
  }
  .container .row .wrapper .label ul{
    padding-left:23px;
    
  }
  .container .row .wrapper .label {
    line-height:2;
  }
}
</style>
